// import React from "react";
// import {
//   FaCity,
//   FaMapMarkedAlt,
//   FaBus,
// } from "react-icons/fa";
// import "./UrbaniaNetwork.css";

// const cities = [
//   {
//     name: "Pune",
//     desc: "Urbania on Rent in Pune for corporate travel, weddings, airport transfers and long-distance tours with premium comfort.",
//   },
//   {
//     name: "Mumbai",
//     desc: "Force Urbania rental service in Mumbai for business travel, outstation trips and luxury group transportation.",
//   },
//   {
//     name: "Nashik",
//     desc: "Urbania bus on rent in Nashik for wine tours, family trips and religious travel with experienced drivers.",
//   },
//   {
//     name: "Shirdi",
//     desc: "Urbania on rent in Shirdi for Sai Baba temple darshan, group pilgrimage and comfortable religious journeys.",
//   },
//   {
//     name: "Aurangabad",
//     desc: "Luxury Urbania rental service in Aurangabad for Ajanta–Ellora tours, family outings and official travel.",
//   },
//   {
//     name: "Kolhapur",
//     desc: "Urbania on rent in Kolhapur for temple visits, weddings and comfortable group transportation.",
//   },
//   {
//     name: "Satara",
//     desc: "Force Urbania hire in Satara for hill station tours, Mahabaleshwar trips and corporate travel.",
//   },
//   {
//     name: "Solapur",
//     desc: "Urbania rental service in Solapur for long-distance journeys, events and business travel.",
//   },
//   {
//     name: "Ahmednagar",
//     desc: "Urbania bus hire in Ahmednagar for weddings, tours and premium travel requirements.",
//   },
//   {
//     name: "Lonavala",
//     desc: "Urbania on rent in Lonavala for weekend trips, resort travel and luxury group tours.",
//   },
//   {
//     name: "Mahabaleshwar",
//     desc: "Urbania rental service for Mahabaleshwar hill station tours with safe and comfortable travel.",
//   },
//   {
//     name: "Nagpur",
//     desc: "Force Urbania on rent in Nagpur for long-route travel, corporate trips and family journeys.",
//   },
// ];

// const UrbaniaNetwork = () => {
//   return (





// <>



// <div
//       className="breadcumb-wrapper"
      
//       data-overlay="black"
//       data-opacity="3"
//     >
//       <div className="container">
//         <div className="breadcumb-content text-center">
//           <h1 className="breadcumb-title">Our Network</h1>
//         </div>
//       </div>
//     </div>

//     <section className="urbania-network-section">
//       <div className="container">
//         {/* HEADER */}
//         {/* <div className="urbania-header text-center">
//           <h2>Urbania On Rent – Our Network</h2>
//           <p>
//             We provide Force Urbania rental services across major Maharashtra
//             cities with professional drivers and premium vehicles.
//           </p>
//         </div> */}

//         {/* GRID */}
//         <div className="row">
//           {cities.map((city, index) => (
//             <div className="col-12 col-md-4 mb-4" key={index}>
//               <div className="urbania-city-card">
//                 <div className="icon-box">
//                   <FaBus />
//                 </div>
//                 <h4>{city.name}</h4>
//                 <p>{city.desc}</p>
//                 <span className="availability">
//                   <FaMapMarkedAlt /> Urbania Available
//                 </span>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>


// </>
//   );
// };

// export default UrbaniaNetwork;











import React from "react";
import "./UrbaniaNetwork.css";

const cities = [
  {
    name: "Pune",
    desc: "Urbania on Rent in Pune for corporate travel, weddings, airport transfers and long-distance tours with premium comfort.",
    img: "/images/fleet/pune.jpg",
  },
  {
    name: "Mumbai",
    desc: "Force Urbania rental service in Mumbai for business travel, outstation trips and luxury group transportation.",
    img: "/images/fleet/mumbai.webp",
  },
    {
    name: "Aurangabad",
    desc: "Luxury Urbania rental service in Aurangabad for Ajanta–Ellora tours, family outings and official travel.",
    img: "/images/fleet/aurangabad.jpg",
  },
 
  {
    name: "Shirdi",
    desc: "Urbania on rent in Shirdi for Sai Baba temple darshan, group pilgrimage and comfortable religious journeys.",
    img: "/images/fleet/shirdi.jpeg",
  },
 {
    name: "Nashik",
    desc: "Urbania bus on rent in Nashik for wine tours, family trips and religious travel with experienced drivers.",
    img: "/images/fleet/nashik.jpeg",
  },
  {
    name: "Kolhapur",
    desc: "Urbania on rent in Kolhapur for temple visits, weddings and comfortable group transportation.",
    img: "/images/fleet/kolhapur.jpeg",
  },
  {
    name: "Satara",
    desc: "Force Urbania hire in Satara for hill station tours, Mahabaleshwar trips and corporate travel.",
    img: "/images/fleet/satara.jpg",
  },
  {
    name: "Solapur",
    desc: "Urbania rental service in Solapur for long-distance journeys, events and business travel.",
    img: "/images/fleet/solapur.jpg",
  },
  {
    name: "Ahmednagar",
    desc: "Urbania bus hire in Ahmednagar for weddings, tours and premium travel requirements.",
    img: "/images/fleet/ahmednagar.webp",
  },
  {
    name: "Lonavala",
    desc: "Urbania on rent in Lonavala for weekend trips, resort travel and luxury group tours.",
    img: "/images/fleet/lonavala.jpg",
  },
  {
    name: "Mahabaleshwar",
    desc: "Urbania rental service for Mahabaleshwar hill station tours with safe and comfortable travel.",
    img: "/images/fleet/mahabaleshwar.jpg",
  },
  {
    name: "Nagpur",
    desc: "Force Urbania on rent in Nagpur for long-route travel, corporate trips and family journeys.",
    img: "/images/fleet/nagpur.jpg",
  },
];

const UrbaniaNetwork = () => {
  return (
    <>
      {/* BREADCRUMB */}
      <div
        className="breadcumb-wrapper"
        data-overlay="black"
        data-opacity="3"
      >
        <div className="container">
          <div className="breadcumb-content text-center">
            <h1 className="breadcumb-title">Our Network</h1>
          </div>
        </div>
      </div>

      {/* NETWORK SECTION */}
      <section className="urbania-network-section">
        <div className="container">
          <div className="row">
            {cities.map((city, index) => (
              <div className="col-12 col-md-4 mb-4" key={index}>
                <div className="urbania-city-card">

                  {/* IMAGE */}
                  <div className="image-box">
                    <img
                      src={city.img}
                      alt={city.name}
                      className="city-image"
                    />
                  </div>

                  {/* CONTENT */}
                  <h4 className="text-center darkcolorrr">{city.name}</h4>
                  <p>{city.desc}</p>

                  <span className="availability">
                    Urbania Available
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default UrbaniaNetwork;